// Author Lin
// Date 2024-06-14 16:09:57

class SithMesInventoryMaterialDispatching {
    constructor({
                    id = null,
                    operationId = '',
                    materialCode = '',
                    quantity = '',
                    productionPlanStartTime = '',
                    dispatchPlanTime = '',
                    dispatchActualTime = '',
                    dispatchActualStation = '',
                    finalLocation = '',
                    dispatchStatus = '',
                    operatorId = '',
                    document = '',
                    documentItem = '',
                    toNumber = '',
                    toNumberItem = '',
                    trackNumber = '',
                    warehouseNumber = '',
                    sourceLocation = '',
                    storageType = '',
                    sourceBin = '',
                    destinationType = '',
                    destinationBin = '',
                    weight = '',
                    sapOffShelfUser = '',
                    sapOffShelfTime = '',
                    dispatchUser = '',
                    operateTime = '',
                    sapChecker = '',
                    sapCheckTime = '',
                    dispatchType = '',
                    dnMaterialId = '',
                    bomItemNumber = '',
                    attachment = '',
                    remark = '',
                    attachmentList = ''
                }
                    = {}) {
        this.id = id;
        this.operationId = operationId;
        this.materialCode = materialCode;
        this.quantity = quantity;
        this.productionPlanStartTime = productionPlanStartTime;
        this.dispatchPlanTime = dispatchPlanTime;
        this.dispatchActualTime = dispatchActualTime;
        this.dispatchActualStation = dispatchActualStation;
        this.finalLocation = finalLocation;
        this.dispatchStatus = dispatchStatus;
        this.operatorId = operatorId;
        this.document = document;
        this.documentItem = documentItem;
        this.toNumber = toNumber;
        this.toNumberItem = toNumberItem;
        this.trackNumber = trackNumber;
        this.warehouseNumber = warehouseNumber;
        this.sourceLocation = sourceLocation;
        this.storageType = storageType;
        this.sourceBin = sourceBin;
        this.destinationType = destinationType;
        this.destinationBin = destinationBin;
        this.weight = weight;
        this.sapOffShelfUser = sapOffShelfUser;
        this.sapOffShelfTime = sapOffShelfTime;
        this.dispatchUser = dispatchUser;
        this.operateTime = operateTime;
        this.sapChecker = sapChecker;
        this.sapCheckTime = sapCheckTime;
        this.dispatchType = dispatchType;
        this.dnMaterialId = dnMaterialId;
        this.bomItemNumber = bomItemNumber;
        this.attachment = attachment;
        this.remark = remark;
        this.attachmentList = attachmentList;
    }
}

function newEntity() {
    return new SithMesInventoryMaterialDispatching();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operationId',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.operationId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderCode',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.orderCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'parentMaterialCode',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.parentMaterialCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'parentMaterialDesc',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.parentMaterialDesc',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operationSeq',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.operationSeq',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialCode',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.materialCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialDescription',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.materialDescription',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchaseType',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.purchaseType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'quantity',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.quantity',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'unit',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.unit',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'productionPlanStartTime',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.productionPlanStartTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'dispatchPlanTime',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.dispatchPlanTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'dispatchActualTime',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.dispatchActualTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'dispatchActualStation',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.dispatchActualStation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'stationCode',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.stationCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'finalLocation',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.finalLocation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'dispatchStatus',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.dispatchStatus',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '0', text: 'SAP下架失败'},
                    {value: '1', text: 'SAP下架成功'},
                    {value: '2', text: '已点件'},
                    {value: '3', text: '配送完成'}
                ]
            }
        },
        {
            key: 'operatorId',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.operatorId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operator',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.operator',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'document',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.document',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'documentItem',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.documentItem',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'toNumber',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.toNumber',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'toNumberItem',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.toNumberItem',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'trackNumber',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.trackNumber',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'warehouseNumber',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.warehouseNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sourceLocation',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.sourceLocation',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'storageType',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.storageType',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sourceBin',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.sourceBin',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'destinationType',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.destinationType',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'destinationBin',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.destinationBin',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'weight',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.weight',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sapOffShelfUser',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.sapOffShelfUser',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sapOffShelfUserName',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.sapOffShelfUserName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sapOffShelfTime',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.sapOffShelfTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'dispatchUser',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.dispatchUser',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'dispatchUserName',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.dispatchUserName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'operateTime',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.operateTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'reservationNumber',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.reservationNumber',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'reservationItem',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.reservationItem',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'plant',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.plant',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'movementType',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.movementType',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'salesOrder',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.salesOrder',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'salesOrderItem',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.salesOrderItem',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'specialStockIndicator',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.specialStockIndicator',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sapChecker',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.sapChecker',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sapCheckerName',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.sapCheckerName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'sapCheckTime',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.sapCheckTime',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'dispatchType',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.dispatchType',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '1', text: '生产物料'},
                    {value: '2', text: 'DN物料'}
                ]
            }
        },
        {
            key: 'dnMaterialId',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.dnMaterialId',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'dnNumber',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.dnNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'dnItem',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.dnItem',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'dnSalesOrder',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.dnSalesOrder',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'bomItemNumber',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.bomItemNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'attachmentList',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.attachmentList',
            sortable: true,
            form: {
                type: 'emAttachment',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.remark',
            sortable: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectName',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.projectName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdByName',
            label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.grid.createdByName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}

const filter = {
    idFilter: '',
    idListFilter: [],
    dnMaterialIdListFilter: [],
    operationIdFilter: '',
    materialCodeFilter: '',
    materialDescriptionFilter: '',
    quantityFilter: '',
    unitFilter: '',
    productionPlanStartTimeRteFilter: '',
    productionPlanStartTimeLteFilter: '',
    dispatchPlanTimeRteFilter: '',
    dispatchPlanTimeLteFilter: '',
    dispatchActualTimeRteFilter: '',
    dispatchActualTimeLteFilter: '',
    dispatchActualStationFilter: '',
    finalLocationFilter: '',
    dispatchStatusFilter: '',
    operatorIdFilter: '',
    documentFilter: '',
    documentItemFilter: '',
    toNumberFilter: '',
    toNumberItemFilter: '',
    trackNumberFilter: '',
    warehouseNumberFilter: '',
    sourceLocationFilter: '',
    storageTypeFilter: '',
    sourceBinFilter: '',
    destinationTypeFilter: '',
    destinationBinFilter: '',
    weightFilter: '',
    sapOffShelfUserFilter: '',
    sapOffShelfTimeRteFilter: '',
    sapOffShelfTimeLteFilter: '',
    dispatchUserFilter: '',
    operateTimeRteFilter: '',
    operateTimeLteFilter: '',
    sapCheckerFilter: '',
    sapCheckerNameFilter: '',
    sapCheckTimeRteFilter: '',
    sapCheckTimeLteFilter: '',
    orderCodeFilter: '',
    operationSeqFilter: '',
    dispatchTypeFilter: '',
    dnMaterialIdFilter: '',
    dnNumberFilter: '',
    bomItemNumberFilter: '',
    projectCodeFilter: '',
    projectNameFilter: '',
    createdByNameFilter: '',
    remarkFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'operationIdFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.operationId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesPrdPpOperation'
            , correspondingField: 'id'
        }
    },
    {
        key: 'materialCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.materialCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quantityFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.quantity',
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'unitFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.unit',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dispatchPlanTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.dispatchPlanTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dispatchPlanTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.dispatchPlanTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dispatchActualTimeRteFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.dispatchActualTimeRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dispatchActualTimeLteFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.dispatchActualTimeLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dispatchActualStationFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.dispatchActualStation',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'id'
        }
    },
    {
        key: 'finalLocationFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.finalLocation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dispatchStatusFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.dispatchStatus',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: 'SAP下架失败'},
                {value: '1', text: 'SAP下架成功'},
                {value: '2', text: '已点件'},
                {value: '3', text: '配送完成'}
            ]
        }
    },
    {
        key: 'operatorIdFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.operatorId',
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'warehouseNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.warehouseNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sourceLocationFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.sourceLocation',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.storageType',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sourceBinFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.sourceBin',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sapCheckerNameFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.sapCheckerName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.orderCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'operationSeqFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.operationSeq',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dispatchTypeFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.dispatchType',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '生产物料'},
                {value: '2', text: 'DN物料'}
            ]
        }
    },
    {
        key: 'dnNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.dnNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'bomItemNumberFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.bomItemNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectNameFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.projectName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdByNameFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.createdByName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remarkFilter',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.filter.remark',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'operationId',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.operationId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            ,
            entity: 'sithMesPrdPpOperation'
            ,
            correspondingField: 'id'
            ,
            fieldsBindingByEntityModalSelected: '{"productionPlanStartTime":"forecastBeginTime", "dispatchActualStation":"actualMstLocationId"}'
        }
    },
    {
        key: 'materialCode',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.materialCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'quantity',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
            type: 'inputNumber',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'productionPlanStartTime',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.productionPlanStartTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dispatchPlanTime',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.dispatchPlanTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dispatchActualTime',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.dispatchActualTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dispatchActualStation',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.dispatchActualStation',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesMstLocation'
            , correspondingField: 'id'
        }
    },
    {
        key: 'finalLocation',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.finalLocation',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dispatchStatus',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.dispatchStatus',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: 'SAP下架失败'},
                {value: '1', text: 'SAP下架成功'},
                {value: '2', text: '已点件'},
                {value: '3', text: '配送完成'}
            ]
        }
    },
    {
        key: 'operatorId',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.operatorId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'id'
        }
    },
    {
        key: 'warehouseNumber',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.warehouseNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sourceLocation',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.sourceLocation',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'storageType',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.storageType',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sourceBin',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.sourceBin',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sapOffShelfUser',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.sapOffShelfUser',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
    {
        key: 'sapOffShelfTime',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.sapOffShelfTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dispatchUser',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.dispatchUser',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
    {
        key: 'operateTime',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.operateTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'sapChecker',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.sapChecker',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'emAclUser'
            , correspondingField: 'loginName'
        }
    },
    {
        key: 'sapCheckTime',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.sapCheckTime',
        sortable: true,
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'dispatchType',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.dispatchType',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '1', text: '生产物料'},
                {value: '2', text: 'DN物料'}
            ]
        }
    },
    {
        key: 'dnMaterialId',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.dnMaterialId',
        sortable: true,
        disabled: false,
        form: {
            type: 'entityModalSelect',
            modalMultiSelectedType: 'string'
            , entity: 'sithMesInventoryDeliveryMaterial'
            , correspondingField: 'id'
        }
    },
    {
        key: 'bomItemNumber',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.bomItemNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'attachmentList',
        label: 'label.sith.inventory.sithMesInventoryMaterialDispatching.entity.attachment',
        sortable: false,
        disabled: false,
        form: {
            type: 'emAttachment',
            modalMultiSelectedType: 'string'
            , correspondingField: 'attachment'
        }
    }
]

export {
    SithMesInventoryMaterialDispatching, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs


}
